import axiosPrivate from "../../../api/axiosPrivate";
import {
  COVER,
  GET_COVER,
  GET_SINGLE_COVER,
  UPDATE_COVER,
} from "../../../api/constant";

// Create new role
const createCover = async (data) => {
  const response = await axiosPrivate.post(COVER, data);
  return response.data;
};

const getAllCover = async (pageNum) => {
  const response = await axiosPrivate.get(`${GET_COVER}?page=${pageNum}`);
  return response.data;
};

const getSingleCover = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_COVER}/${id}`);
  return response.data;
};

const updateCover = async (data) => {
  const response = await axiosPrivate.post(`${UPDATE_COVER}/${data.id}`, data);
  return response.data;
};

const coverService = {
  createCover,
  getAllCover,
  getSingleCover,
  updateCover,
};
export default coverService;
